import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row, Card, CardBody } from 'reactstrap';

import { Input, TableLangValue } from '@/components/form';
import ResourceForm from '@/components/resources/form';
import View from '@/components/view';

const ExpectedResponsePatternForm = ({ match }) => {
  return (
    <View>
      <ResourceForm
        resource="ExpectedResponsePattern"
        id={match.params.id}
        initialValues={{ alias: '', values: null, name: {}, icon: null }}
      >
        {({ submitting, renderActions }) => (
          <>
            <Card>
              <CardBody className={submitting ? 'loading' : ''}>
                <Row>
                  <Col lg={6}>
                    <Input type="textarea" name="helpMessage" placeholder="message" />
                  </Col>
                  <Col lg={12}>
                    <TableLangValue name="name" />
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <div className="mt-4 mb-4">{renderActions()}</div>
          </>
        )}
      </ResourceForm>
    </View>
  );
};

ExpectedResponsePatternForm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
  }).isRequired
};

export default ExpectedResponsePatternForm;
